








































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { maskDateTime } from '@/utils/common'
import { MedicoElegivelCirurgiaConjunta } from '@/types/interfaces/CirurgiaConjunta'

@Component
export default class ModalVincularSolicitacaoCirurgiaConjunta extends Vue {
  @Prop() visible: boolean
  @Prop() medico: MedicoElegivelCirurgiaConjunta | null
  @Prop({ default: false }) disabled: boolean

  solicitacaoSelecionada: string | null = null

  @Watch('medico')
  onMedicoChange(medico: MedicoElegivelCirurgiaConjunta | null) {
    const primeiraSolicitacao = medico && medico.solicitacoes && medico.solicitacoes[0]
    this.solicitacaoSelecionada = primeiraSolicitacao ? primeiraSolicitacao.id : null
  }

  get show() {
    return this.visible
  }

  set show(val: boolean) {
    if (!val) {
      this.close()
    }
  }

  solicitacaoLabel(solicitacao: { data: string | null, procedimentoPrincipal?: string }) {
    const data = solicitacao.data ? maskDateTime(solicitacao.data) : 'Sem data'

    return solicitacao.procedimentoPrincipal
      ? `${data} · ${solicitacao.procedimentoPrincipal}`
      : data
  }

  @Emit('close')
  close() {}

  confirmar() {
    this.$emit('confirmar', this.solicitacaoSelecionada)
    this.close()
  }
}
